import ServiceBus from 'servicestack/service-bus'

class DashboardSalesComparisonController  {
    constructor(createAutoQuery, $session) {
        this.$session = $session;
    }

    load() {
        let $ctrl = this;
        var bus = new ServiceBus();
        var request = {
            reportName: "DashboardSalesByRepGroup",
            dateRange: "YTD",
            status: "Open,Review,Completed,On Hold"
        }
        bus.send('RunReport.json', request).then(function (response) {
            $ctrl.query = response.data; 
        });
    }
}

class DashboardSalesComparison{
    constructor(){
        this.bindings= {
            date: '@',
        };
        this.controller = DashboardSalesComparisonController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-sales-comparison.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardSalesComparison', new DashboardSalesComparison());

export default DashboardSalesComparison